module.exports = __webpack_public_path__ + "static/media/FAQ.89d63904.svg";